var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconVolumeOff48Line = function SvgIconVolumeOff48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2 11.12c-1.07-.46-2.3-.24-3.14.56l-6.49 6.12h-.72a5.31 5.31 0 0 0-5.3 5.3v1.8c0 2.92 2.38 5.3 5.3 5.3h.72l6.49 6.12a2.883 2.883 0 0 0 3.14.55c1.06-.46 1.75-1.5 1.75-2.66V13.78c0-1.16-.69-2.2-1.75-2.66Zm-1.65 21.94-6.13-5.79c-.32-.3-.73-.46-1.17-.46h-1.4a1.9 1.9 0 0 1-1.9-1.9v-1.8c0-1.05.85-1.9 1.9-1.9h1.4c.43 0 .85-.17 1.17-.46l6.13-5.79v18.11-.01ZM39.45 20.2l-2.4-2.4-3.8 3.8-3.8-3.8-2.4 2.4 3.79 3.8-3.79 3.8 2.4 2.4 3.8-3.8 3.8 3.8 2.4-2.4-3.8-3.8 3.8-3.8Z",
    fill: "current"
  })));
};
export default SvgIconVolumeOff48Line;